import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'
const API_PATH = 'api/v2/admins/customers'

const CustomersApiV2 = {

  /**
   * Get list of customers
   * Invoke `GET api/v2/admins/customers
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },
  /**
   * Get list of customer addresses
   * Invoke `GET api/v2/admins/customers/:id/addresses
   * @param {number} customerId - customerId number`
   */
  getAddresses: async ({ customerId }) => {
    const path = `${API_PATH}/${customerId}/addresses`

    const response = axios.get(path, { })
    return response
  },
  /**
   * Get one `Customer`
   * @param {object} id customer id
   * @return {object} `customer`
   */
  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },
  /**
   * Create customer endpoint.
   * Invoke `POST api/v2/admins/customers`
   * @param {object} customer_values
   */
  create: async (customer_values) => {
    const path = API_PATH

    const response = axios.post(path, customer_values)
    return response
  },
  /**
   * update `Customer` profile data
   * @param {number} id customer id
   * @param {object} values values for customer update
   * @return {object} `Customer`
   */
  update: async (id, values) => {
    const path = `${API_PATH}/${id}`

    const response = axios.patch(path, values)
    return response
  }
}

export default CustomersApiV2
